import React from "react"
import PropTypes from "prop-types"
import { graphql, Link } from "gatsby"
import tw from "twin.macro"

import SEO from "../components/seo"
import "./doc.css"

import Layout, { PageTitle } from "../components/layout"
import DocToc from "../components/doc-toc"
import DocFoundation from "../components/doc-foundation"

const Wrapper = tw.div`flex flex-col-reverse lg:flex-row`
const TocCol = tw.div`mt-8 lg:mt-0 lg:w-1/3`
const Content = tw.div`flex-1`
const BackLink = tw(Link)`lg:hidden text-ql-gray uppercase`

const Template = ({ data }) => {
  const { markdownRemark } = data
  const { frontmatter, html } = markdownRemark
  const toc = [
    {
      title: "Getting Started",
      links: data.start.edges
    },
    {
      title: "Labels",
      links: data.labels.edges
    },
    {
      title: "Configuration",
      links: data.config.edges
    },
    {
      title: "Troubleshooting",
      links: data.help.edges
    }
  ]
  return (
    <Layout Foundation={DocFoundation}>
      <BackLink to="/docs">‹ All Documentation</BackLink>
      <Wrapper>
        <TocCol>
          <DocToc toc={toc} />
        </TocCol>
        <Content>
          <SEO title={frontmatter.title}/>
          <PageTitle>{frontmatter.title}</PageTitle>
          <div
            className="doc-content"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </Content>
      </Wrapper>
    </Layout>
  )
}

Template.propTypes = {
  data: PropTypes.object
}

export default Template

export const pageQuery = graphql`
  query($title: String!) {
    markdownRemark(frontmatter: { title: { eq: $title } }) {
      html
      frontmatter {
        title
      }
    }
    start: allMarkdownRemark(
      filter: { frontmatter: { section: { eq: "start" } } }
    ) {
      ...MarkdownRemarkConnectionFragment
    }
    labels: allMarkdownRemark(
      filter: { frontmatter: { section: { eq: "labels" } } }
    ) {
      ...MarkdownRemarkConnectionFragment
    }
    config: allMarkdownRemark(
      filter: { frontmatter: { section: { eq: "config" } } }
    ) {
      ...MarkdownRemarkConnectionFragment
    }
    help: allMarkdownRemark(
      filter: { frontmatter: { section: { eq: "help" } } }
    ) {
      ...MarkdownRemarkConnectionFragment
    }
  }
  fragment MarkdownRemarkConnectionFragment on MarkdownRemarkConnection {
    edges {
      node {
        frontmatter {
          title
          slug
        }
        id
      }
    }
  }
`
